import { defineMessages } from 'react-intl';

export default defineMessages({

  ifYesPleaseProvide: {
    id: 'fastCover.medicalExpenseStep.ifYesPleaseProvide',
    defaultMessage: 'If so, please provide the Company Name and Address',
  },

  didYouHaveOtherMedicalInsurance: {
    id: 'fastCover.medicalExpenseStep.didYouHaveOtherMedicalInsurance',
    defaultMessage: 'Did you have other medical insurance?',
  },

  doYouHaveAnyOtherTypeOfCoverage: {
    id: 'fastCover.medicalExpenseStep.doYouHaveAnyOtherTypeOfCoverage',
    defaultMessage: 'Do you have any other type of coverage?',
  },

  insuranceCarriersName: {
    id: 'fastCover.medicalExpenseStep.insuranceCarriersName',
    defaultMessage: "Insurance Carrier's Name",
  },

  address: {
    id: 'fastCover.medicalExpenseStep.address',
    defaultMessage: 'Address',
  },

  cityOrTown: {
    id: 'fastCover.medicalExpenseStep.cityOrTown',
    defaultMessage: 'City or Town',
  },

  country: {
    id: 'fastCover.medicalExpenseStep.country',
    defaultMessage: 'Country',
  },

  postalCode: {
    id: 'fastCover.medicalExpenseStep.postalCode',
    defaultMessage: 'Postal Code',
  },

  policyId: {
    id: 'fastCover.medicalExpenseStep.policyId',
    defaultMessage: 'Policy ID',
  },

  contact: {
    id: 'fastCover.medicalExpenseStep.contact',
    defaultMessage: 'Contact',
  },

  email: {
    id: 'fastCover.medicalExpenseStep.email',
    defaultMessage: 'Email',
  },

  phoneNumber: {
    id: 'fastCover.medicalExpenseStep.phoneNumber',
    defaultMessage: 'Phone Number',
  },

  areYouACitizenOfTheEuropeanUnion: {
    id: 'fastCover.medicalExpenseStep.areYouACitizenOfTheEuropeanUnion',
    defaultMessage: 'Are you a citizen of the European Union?',
  },

  forEUCitizens: {
    id: 'fastCover.medicalExpenseStep.forEUCitizens',
    defaultMessage: 'Was a European Health Insurance Card (EHIC) taken on this trip?',
  },

  ifYesWasTheEHIC: {
    id: 'fastCover.medicalExpenseStep.ifYesWasTheEHIC',
    defaultMessage: 'If yes, was the EHIC presented to the hospital or physician?',
  },

  ifNoPleaseExplain: {
    id: 'fastCover.medicalExpenseStep.ifNoPleaseExplain',
    defaultMessage: 'If no, please explain',
  },

  place: {
    id: 'fastCover.medicalExpenseStep.place',
    defaultMessage: 'Place',
  },

  expensesClaimed: {
    id: 'fastCover.medicalExpenseStep.expensesClaimed',
    defaultMessage: 'Expenses Claimed',
  },

  currency: {
    id: 'fastCover.medicalExpenseStep.currency',
    defaultMessage: 'Currency',
  },


  yes: {
    id: 'fastCover.medicalExpenseStep.yes',
    defaultMessage: 'Yes',
  },

  no: {
    id: 'fastCover.medicalExpenseStep.no',
    defaultMessage: 'No',
  },
  //---------------------------
  areYouClaimingForDamagedLostOrStolenLuggage: {
    id: 'fastCover.medicalExpenseStep.areYouClaimingForDamagedLostOrStolenLuggage',
    defaultMessage: 'Are you claiming for Damaged, Lost, or Stolen Luggage?',
  },

  areYouClaimingForBaggageDelay: {
    id: 'fastCover.medicalExpenseStep.areYouClaimingForBaggageDelay',
    defaultMessage: 'Are you claiming for Baggage Delay?',
  },

  areYouClaimingFor: {
    id: 'fastCover.medicalExpenseStep.areYouClaimingFor',
    defaultMessage: 'Are you claiming for:',
  },

  travelSupplierProviderInformation: {
    id: 'fastCover.medicalExpenseStep.travelSupplierProviderInformation',
    defaultMessage: 'Travel Supplier / Provider Information',
  },

  companyYouWereTravelingWith: {
    id: 'fastCover.medicalExpenseStep.companyYouWereTravelingWith',
    defaultMessage: 'Company you were traveling with:',
  },

  origin: {
    id: 'fastCover.medicalExpenseStep.origin',
    defaultMessage: 'Origin',
  },

  flightNumber: {
    id: 'fastCover.medicalExpenseStep.flightNumber',
    defaultMessage: 'Flight Number',
  },

  airCarrier: {
    id: 'fastCover.medicalExpenseStep.airCarrier',
    defaultMessage: 'Air Carrier',
  },

  destination: {
    id: 'fastCover.medicalExpenseStep.destination',
    defaultMessage: 'Destination',
  },

  lossInformation: {
    id: 'fastCover.medicalExpenseStep.lossInformation',
    defaultMessage: 'Loss Information',
  },

  dateOfLoss: {
    id: 'fastCover.medicalExpenseStep.dateOfLoss',
    defaultMessage: 'Date of Loss',
  },

  pleaseDescribeWhatOccurred: {
    id: 'fastCover.medicalExpenseStep.pleaseDescribeWhatOccurred',
    defaultMessage: 'Please describe what occurred',
  },

  whoDidYouReportTo: {
    id: 'fastCover.medicalExpenseStep.whoDidYouReportTo',
    defaultMessage: 'Who did you report to?',
  },

  reportReferenceNumber: {
    id: 'fastCover.medicalExpenseStep.reportReferenceNumber',
    defaultMessage: 'Report Reference Number',
  },

  nameAndAddress: {
    id: 'fastCover.medicalExpenseStep.nameAndAddress',
    defaultMessage: 'Name and Address',
  },

  nameCustomerServiceDepartment: {
    id: 'fastCover.medicalExpenseStep.nameCustomerServiceDepartment',
    defaultMessage: 'Name (Customer Service Department)',
  },

  doYouHaveAnyFurtherDetailsToAdd: {
    id: 'fastCover.medicalExpenseStep.doYouHaveAnyFurtherDetailsToAdd',
    defaultMessage: 'Do you have any further details to add',
  },

  loss: {
    id: 'fastCover.medicalExpenseStep.loss',
    defaultMessage: 'Loss',
  },

  theft: {
    id: 'fastCover.medicalExpenseStep.theft',
    defaultMessage: 'Theft',
  },

  damage: {
    id: 'fastCover.medicalExpenseStep.damage',
    defaultMessage: 'Damage',
  },

  tourOperator: {
    id: 'fastCover.medicalExpenseStep.tourOperator',
    defaultMessage: 'Tour Operator',
  },

  cruiseLine: {
    id: 'fastCover.medicalExpenseStep.cruiseLine',
    defaultMessage: 'Cruise Line',
  },

  airline: {
    id: 'fastCover.medicalExpenseStep.airline',
    defaultMessage: 'Airline',
  },

  airport: {
    id: 'fastCover.medicalExpenseStep.airport',
    defaultMessage: 'Airport',
  },

  hotel: {
    id: 'fastCover.medicalExpenseStep.hotel',
    defaultMessage: 'Hotel',
  },

  rentalAgency: {
    id: 'fastCover.medicalExpenseStep.rentalAgency',
    defaultMessage: 'Rental Agency',
  },

  police: {
    id: 'fastCover.medicalExpenseStep.police',
    defaultMessage: 'Police',
  },

  hospitalManagement: {
    id: 'fastCover.medicalExpenseStep.hospitalManagement',
    defaultMessage: 'Hospital Management',
  },

  cruiseShip: {
    id: 'fastCover.medicalExpenseStep.cruiseShip',
    defaultMessage: 'Cruise Ship',
  },

  tourGuide: {
    id: 'fastCover.medicalExpenseStep.tourGuide',
    defaultMessage: 'Tour Guide',
  },

  notReported: {
    id: 'fastCover.medicalExpenseStep.notReported',
    defaultMessage: 'Not Reported',
  },

  addItem: {
    id: 'fastCover.medicalExpenseStep.addItem',
    defaultMessage: 'Add Date',
  },

  itemWithIdx: {
    id: 'fastCover.medicalExpenseStep.itemWithIdx',
    defaultMessage: 'Item(s) {idx}',
  },

  item: {
    id: 'fastCover.medicalExpenseStep.item',
    defaultMessage: 'Item',
  },

  estimatedValue: {
    id: 'fastCover.medicalExpenseStep.estimatedValue',
    defaultMessage: 'Estimated Value',
  },

  haveYouReceivedReimbursement: {
    id: 'fastCover.medicalExpenseStep.haveYouReceivedReimbursement',
    defaultMessage: 'Have you received Reimbursement?',
  },

  fromWhom: {
    id: 'fastCover.medicalExpenseStep.fromWhom',
    defaultMessage: 'If so, from whom?',
  },

  howMuch: {
    id: 'fastCover.medicalExpenseStep.howMuch',
    defaultMessage: 'How much?',
  },

  totalExpensesClaimed: {
    id: 'fastCover.medicalExpenseStep.totalExpensesClaimed',
    defaultMessage: 'Total Expenses Claimed',
  },

  addPrescriptionMedicines: {
    id: 'fastCover.medicalExpenseStep.addPrescriptionMedicines',
    defaultMessage: 'Add Prescription medicine',
  },

  prescriptionMedicinesV1: {
    id: 'fastCover.medicalExpenseStep.prescriptionMedicinesV1',
    defaultMessage: 'Prescription medicines you have been prescribed for your injury or illness',
  },

  dosage: {
    id: 'fastCover.medicalExpenseStep.dosage',
    defaultMessage: 'Dosage',
  },

  nameOfPrescribingDoctor: {
    id: 'fastCover.medicalExpenseStep.nameOfPrescribingDoctor',
    defaultMessage: 'Name of Prescribing Doctor',
  },

  prescriptionMedicinesV2: {
    id: 'fastCover.medicalExpenseStep.prescriptionMedicinesYouHave',
    defaultMessage: 'Prescription medicines, herbal medications or vitamins you took prior to your effective date that are not related to your injury/illness',
  },

  // changeTo: {
  //   id: 'fastCover.medicalExpenseStep.changeTo',
  //   defaultMessage: 'Is this a claim due to an unexpected recurrence or a pre-existing condition?',
  // },

  // ifYesNameOfPhysicianCurrentlyTreatingThis: {
  //   id: 'fastCover.medicalExpenseStep.ifYesNameOfPhysicianCurrentlyTreatingThis',
  //   defaultMessage: 'If yes, name of physician currently treating this',
  // },

  // ------------------------------------------------------------------------------------

  tripCancellation: {
    id: 'fastCover.medicalExpenseStep.tripCancellation',
    defaultMessage: 'Are you claiming for Trip Cancellation?',
  },

  travelInterruption: {
    id: 'fastCover.medicalExpenseStep.travelInterruption',
    defaultMessage: 'Are you claiming for Travel Interruption?',
  },

  travelDelay: {
    id: 'fastCover.medicalExpenseStep.travelDelay',
    defaultMessage: 'Are you claiming for Travel Delay?',
  },

  reasonsForTripInterruption: {
    id: 'fastCover.medicalExpenseStep.reasonsForTripInterruption',
    defaultMessage: 'Reasons for Trip Interruption',
  },

  reasons1: {
    id: 'fastCover.medicalExpenseStep.reasons1',
    defaultMessage: 'Death of an Immediate Family Member',
  },

  reasons2: {
    id: 'fastCover.medicalExpenseStep.reasons2',
    defaultMessage: 'You Unforeseen Sickness or Injury or, the Sickness or Injury if a Traveling Companion or Immediate Family Member',
  },

  reasons3: {
    id: 'fastCover.medicalExpenseStep.reasons3',
    defaultMessage: 'Substantial destruction of your principal residence by fire or weather-related activity a Medically Necessary covered Emergency Medical Evacuation to return to Your Home Country',
  },

  reasons4: {
    id: 'fastCover.medicalExpenseStep.reasons4',
    defaultMessage: 'or to the area from which You were initially evacuated for continued treatment, recuperation, and recovery',
  },

  travelSupplier: {
    id: 'fastCover.medicalExpenseStep.travelSupplier',
    defaultMessage: 'Travel Supplier / Provider Information',
  },

  addressTravelInterruption: {
    id: 'fastCover.medicalExpenseStep.addressTravelInterruption',
    defaultMessage: 'Address',
  },

  cityTravelInterruption: {
    id: 'fastCover.medicalExpenseStep.cityTravelInterruption',
    defaultMessage: 'City',
  },

  stateTravelInterruption: {
    id: 'fastCover.medicalExpenseStep.stateTravelInterruption',
    defaultMessage: 'State',
  },

  zipCodeTravelInterruption: {
    id: 'fastCover.medicalExpenseStep.zipCodeTravelInterruption',
    defaultMessage: 'Zip code',
  },

  contactTravelInterruption: {
    id: 'fastCover.medicalExpenseStep.contactTravelInterruption',
    defaultMessage: 'Contact',
  },

  includedInPackage: {
    id: 'fastCover.medicalExpenseStep.includedInPackage',
    defaultMessage: 'If not included in package, how was air travel arranged?',
  },

  addLossInformation: {
    id: 'fastCover.medicalExpenseStep.addLossInformation',
    defaultMessage: 'Add Loss Information',
  },

  dateTripInterrupted: {
    id: 'fastCover.medicalExpenseStep.dateTripInterrupted',
    defaultMessage: 'Date Trip was Interrupted',
  },

  lossInformationWithIdx: {
    id: 'fastCover.medicalExpenseStep.lossInformationWithIdx',
    defaultMessage: 'Loss information {idx}',
  },

  reasonForInterruption: {
    id: 'fastCover.medicalExpenseStep.reasonForInterruption',
    defaultMessage: 'Reason for interruption',
  },

  nameOfPersonHavingSickness: {
    id: 'fastCover.medicalExpenseStep.nameOfPersonHavingSickness',
    defaultMessage: 'Name of person having sickness of injury',
  },

  dateOfBirth: {
    id: 'fastCover.medicalExpenseStep.dateOfBirth',
    defaultMessage: 'His/Her date of birth',
  },

  relationshipToClaimant: {
    id: 'fastCover.medicalExpenseStep.relationshipToClaimant',
    defaultMessage: 'His/Her relationship to claimant',
  },

  dateEnded: {
    id: 'fastCover.medicalExpenseStep.dateEnded',
    defaultMessage: 'Date ended',
  },

  natureOfSicknessOrInjury: {
    id: 'fastCover.medicalExpenseStep.natureOfSicknessOrInjury',
    defaultMessage: 'Nature of Sickness or Injury (If Injury, describe accident, including date and place):',
  },

  periodOfHospitalization: {
    id: 'fastCover.medicalExpenseStep.periodOfHospitalization',
    defaultMessage: 'Period of hospitalization (If applicable):',
  },

  companyNameLoss: {
    id: 'fastCover.medicalExpenseStep.companyNameLoss',
    defaultMessage: 'Company name (airline/hotel/cruse/travel agent/ect.)',
  },

  amountPaidLoss: {
    id: 'fastCover.medicalExpenseStep.amountPaidLoss',
    defaultMessage: 'Amount Paid (total for all insureds)',
  },

  amountOfLoss: {
    id: 'fastCover.medicalExpenseStep.amountOfLoss',
    defaultMessage: 'Amount of Loss (non-refundable amount)',
  },

  howMuchReceivedReimbursement: {
    id: 'fastCover.medicalExpenseStep.howMuchReceivedReimbursement',
    defaultMessage: 'How much?',
  },

  reasonsForDelay: {
    id: 'fastCover.medicalExpenseStep.reasonsForDelay',
    defaultMessage: 'Reasons for Delay',
  },

  reasons1ForTravelDelay: {
    id: 'fastCover.medicalExpenseStep.reasons1ForTravelDelay',
    defaultMessage: 'Delay of a Common Carrier (including Inclement Weather)',
  },

  reasons2ForTravelDelay: {
    id: 'fastCover.medicalExpenseStep.reasons2ForTravelDelay',
    defaultMessage: 'Delay by a traffic Accident en router to a departure, in which You or Your Traveling Companion is not directly involved',
  },

  reasons3ForTravelDelay: {
    id: 'fastCover.medicalExpenseStep.reasons3ForTravelDelay',
    defaultMessage: 'Delay due to lost or stolen passport, travel documents or money, Quarantine, hijacking, unannounced Strike, Natural Disaster, civil commotion, or riot',
  },

  reasons4ForTravelDelay: {
    id: 'fastCover.medicalExpenseStep.reasons4ForTravelDelay',
    defaultMessage: 'A closed roadway causing cessation of travel to the destination of the Trip (substantiated by the department of transportation, state police, etc.)',
  },

  dateYouWereDueToDepart: {
    id: 'fastCover.medicalExpenseStep.dateYouWereDueToDepart',
    defaultMessage: 'Date you were due to depart',
  },

  timeYouWereDueToDepart: {
    id: 'fastCover.medicalExpenseStep.timeYouWereDueToDepart',
    defaultMessage: 'Time you were due to depart',
  },

  dateTripWasDelayed: {
    id: 'fastCover.medicalExpenseStep.dateTripWasDelayed',
    defaultMessage: 'Date trip was delayed with Travel Supplier',
  },

  dateDelayEnded: {
    id: 'fastCover.medicalExpenseStep.dateDelayEnded',
    defaultMessage: 'Date delay ended',
  },

  dateYouActuallyDeparted: {
    id: 'fastCover.medicalExpenseStep.dateYouActuallyDeparted',
    defaultMessage: 'Date you actually departed',
  },

  timeYouActuallyDeparted: {
    id: 'fastCover.medicalExpenseStep.timeYouActuallyDeparted',
    defaultMessage: 'Time you actually departed',
  },

  delayInformation: {
    id: 'fastCover.medicalExpenseStep.delayInformation',
    defaultMessage: 'Delay Information',
  },

  addDelayInformation: {
    id: 'fastCover.medicalExpenseStep.addDelayInformation',
    defaultMessage: 'Add Delay Information',
  },

  delayInformationWithIdx: {
    id: 'fastCover.medicalExpenseStep.delayInformationWithIdx',
    defaultMessage: 'Delay information {idx}',
  },

  //-----------------------------------------------------------------------------------------

  howItHappened: {
    id: 'fastCover.medicalExpenseStep.howItHappened',
    defaultMessage: '1. How it happened',
  },
  whereYouWereInRelationToTheItem: {
    id: 'fastCover.medicalExpenseStep.whereYouWereInRelationToTheItem',
    defaultMessage:
      'Provide details of where you were in relation to the item at the time of loss, theft or damage',
  },
  anyThingAdditionalToAdd: {
    id: 'fastCover.medicalExpenseStep.anyThingAdditionalToAdd',
    defaultMessage: 'Do you have any further details to add?',
  },
  delay: {
    id: 'fastCover.medicalExpenseStep.delay',
    defaultMessage: 'Delay',
  },
  hotelManagement: {
    id: 'fastCover.medicalExpenseStep.hotelManagement',
    defaultMessage: 'Hotel Management',
  },
  otherDescription: {
    id: 'fastCover.medicalExpenseStep.otherDescription',
    defaultMessage: 'If yes, please describe',
  },
  descriptionOfItems: {
    id: 'fastCover.medicalExpenseStep.descriptionOfItems',
    defaultMessage: 'Description of items',
  },
  datePurchased: {
    id: 'fastCover.medicalExpenseStep.datePurchased',
    defaultMessage: 'Date purchased',
  },
  storeWhereItemWasPurchased: {
    id: 'fastCover.medicalExpenseStep.storeWhereItemWasPurchased',
    defaultMessage: 'Store where item was purchased',
  },
  purchasePrice: {
    id: 'fastCover.medicalExpenseStep.purchasePrice',
    defaultMessage: 'Purchase price',
  },
  amountClaimed: {
    id: 'fastCover.medicalExpenseStep.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  proofOfPurchaseAttached: {
    id: 'fastCover.medicalExpenseStep.proofOfPurchaseAttached',
    defaultMessage: 'Proof of purchase attached',
  },
  addAdditionalItem: {
    id: 'fastCover.medicalExpenseStep.addAdditionalItem',
    defaultMessage: 'Add Additional Item',
  },
  additionalItem: {
    id: 'fastCover.medicalExpenseStep.additionalItem',
    defaultMessage: 'Luggage and Personal Items',
  },
  claimed: {
    id: 'fastCover.medicalExpenseStep.claimed',
    defaultMessage: 'Claimed',
  },
  nameOfTransportProvider: {
    id: 'fastCover.medicalExpenseStep.nameOfTransportProvider',
    defaultMessage:
      'Name of Transport Provider (airline, cruise liner, bus etc.)',
  },
  dateWhenYourLuggageWasDelayed: {
    id: 'fastCover.medicalExpenseStep.dateWhenYourLuggageWasDelayed',
    defaultMessage: 'Date when your luggage was delayed',
  },
  timeWhenYourLuggageWasDelayed: {
    id: 'fastCover.medicalExpenseStep.timeWhenYourLuggageWasDelayed',
    defaultMessage: 'Time when your luggage was delayed',
  },
  dateWhenYourLuggageWasReturned: {
    id: 'fastCover.medicalExpenseStep.dateWhenYourLuggageWasReturned',
    defaultMessage: 'Date when your luggage was returned',
  },
  timeWhenYourLuggageWasReturned: {
    id: 'fastCover.medicalExpenseStep.timeWhenYourLuggageWasReturned',
    defaultMessage: 'Time when your luggage was returned',
  },
  paidForDelay: {
    id: 'fastCover.medicalExpenseStep.paidForDelay',
    defaultMessage: 'Were you paid any compensation for this delay?',
  },
  madeClaimWithTravelProviderOrOther: {
    id: 'fastCover.medicalExpenseStep.madeClaimWithTravelProviderOrOther',
    defaultMessage:
      'Have you made a claim with your Travel Provider (Airline, hotel, cruise liner, tour company etc.) or any other company responsible for the loss, theft, damage or delay of your luggage?',
  },
  listedOnThePolicy: {
    id: 'fastCover.medicalExpenseStep.listedOnThePolicy',
    defaultMessage:
      'Are the luggage or personal item(s) lost, stolen, damaged or delayed owned by you or someone else listed on the policy?',
  },
  damagedLostOrStolenLuggageItems: {
    id: 'fastCover.medicalExpenseStep.damagedLostOrStolenLuggageItems',
    defaultMessage: 'Damaged, Lost or Stolen Luggage Items',
  },
  delayedLuggageExpenses: {
    id: 'fastCover.medicalExpenseStep.delayedLuggageExpenses',
    defaultMessage: 'Delayed Luggage Expenses',
  },
  delayedLuggageExpense: {
    id: 'fastCover.medicalExpenseStep.delayedLuggageExpense',
    defaultMessage: 'Delayed Luggage Expense',
  },
  isRequired: {
    id: 'fastCover.medicalExpenseStep.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  expenseTableRequired: {
    id: 'fastCover.medicalExpenseStep.expenseTableRequired',
    defaultMessage: 'Expense table fields are mandatory fields.',
  },
  addDelayedLuggageExpense: {
    id: 'fastCover.medicalExpenseStep.addDelayedLuggageExpense',
    defaultMessage: 'Add Delayed Luggage Expense',
  },
  dateCompensationWasReceived: {
    id: 'fastCover.medicalExpenseStep.dateCompensationWasReceived',
    defaultMessage: 'Date compensation was received',
  },
  compensationDescription: {
    id: 'fastCover.medicalExpenseStep.compensationDescription',
    defaultMessage: 'Compensation description',
  },
  amountOfCompensation: {
    id: 'fastCover.medicalExpenseStep.delayedTravel.amountOfCompensation',
    defaultMessage: 'Compensation received',
  },
  amountOfCompensationCurrency: {
    id: 'fastCover.medicalExpenseStep.delayedTravel.amountOfCompensationCurrency',
    defaultMessage: 'Currency',
  },
  currencyEg: {
    id: 'fastCover.medicalExpenseStep.currencyEg',
    defaultMessage: 'E.g.Euro',
  },
  delayedLuggageExpenseWithIdx: {
    id: 'fastCover.medicalExpenseStep.delayedLuggageExpenseWithIdx',
    defaultMessage: 'Delayed Luggage Expense {idx}',
  },
  checkEventDate: {
    id: 'fastCover.medicalExpenseStep.checkEventDate',
    defaultMessage: "'{defaultMessage}' cannot be in the future.",
  },

  // New Screen
  travelInformation: {
    id: 'fastCover.medicalExpenseStep.travelInformation',
    defaultMessage: 'Travel Information',
  },
  dateTravelArrangementsWereMade: {
    id: 'fastCover.medicalExpenseStep.dateTravelArrangementsWereMade',
    defaultMessage: 'Date Travel Arrangements were made',
  },
  dateOfInitialPaymentDeposit: {
    id: 'fastCover.medicalExpenseStep.dateOfInitialPaymentDeposit',
    defaultMessage: 'Date of initial payment deposit',
  },
  typeOfPolicy: {
    id: 'fastCover.medicalExpenseStep.typeOfPolicy',
    defaultMessage: 'Type Of Policy',
  },
  haveYouFiledAClaimWithTheirOfficeAtThisTime: {
    id: 'fastCover.medicalExpenseStep.haveYouFiledAClaimWithTheirOfficeAtThisTime',
    defaultMessage: 'Have you filed a claim with their office at this time?',
  },
  nameOfPersonHavingSicknessOrInjury: {
    id: 'fastCover.medicalExpenseStep.nameOfPersonHavingSicknessOrInjury',
    defaultMessage: 'Name of person having sickness or injury',
  },
  hisOrHerDateOfBirth: {
    id: 'fastCover.medicalExpenseStep.hisOrHerDateOfBirth',
    defaultMessage: 'His / Her date of birth',
  },
  isTheClaimTheResultOfASicknessOrInjury: {
    id: 'fastCover.medicalExpenseStep.isTheClaimTheResultOfASicknessOrInjury',
    defaultMessage: 'Is the claim the result of a Sickness/Injury',
  },
  natureOfSickness: {
    id: 'fastCover.medicalExpenseStfep.natureOfSickness',
    defaultMessage: 'Nature of Sickness',
  },
  accident: {
    id: 'fastCover.medicalExpenseStep.accident',
    defaultMessage: 'Accident',
  },
  date: {
    id: 'fastCover.medicalExpenseStep.date',
    defaultMessage: 'Date',
  },
  wasThereAnAccidentReportForThisIncident: {
    id: 'fastCover.medicalExpenseStep.wasThereAnAccidentReportForThisIncident',
    defaultMessage: 'Was there an accident report for this incident?',
  },
  sickness: {
    id: 'fastCover.medicalExpenseStep.sickness',
    defaultMessage: 'Sickness',
  },
  injury: {
    id: 'fastCover.medicalExpenseStep.injury',
    defaultMessage: 'Injury',
  },
  fromDate: {
    id: 'fastCover.medicalExpenseStep.fromDate',
    defaultMessage: 'From',
  },
  toDate: {
    id: 'fastCover.medicalExpenseStep.toDate',
    defaultMessage: 'To',
  },
  wasThereAnyPreviousTreatmentForThisCondition: {
    id: 'fastCover.medicalExpenseStep.wasThereAnyPreviousTreatmentForThisCondition',
    defaultMessage: 'Was there any previous treatment for this condition?',
  },
  nameOfProvider: {
    id: 'fastCover.medicalExpenseStep.nameOfProvider',
    defaultMessage: 'Name Of Provider',
  },
  dateIncurred: {
    id: 'fastCover.medicalExpenseStep.dateIncurred',
    defaultMessage: 'Date Incurred',
  },
  amountOfBill: {
    id: 'fastCover.medicalExpenseStep.amountOfBill',
    defaultMessage: 'Amount Of Bill',
  },
  amountPaidByOtherInsurance: {
    id: 'fastCover.medicalExpenseStep.amountPaidByOtherInsurance',
    defaultMessage: 'Amount Paid by Other Insurance',
  },
  pleaseNoteTheirResponse: {
    id: 'fastCover.medicalExpenseStep.pleaseNoteTheirResponse',
    defaultMessage: 'Please Note Their Response',
  },
  whyNot: {
    id: 'fastCover.medicalExpenseStep.whyNot',
    defaultMessage: 'Why Not',
  },

  illnessOrAccidentStatement: {
    id: 'fastCover.medicalExpenseStep.illnessOrAccidentStatement',
    defaultMessage: 'ILLNESS/ACCIDENT STATEMENT',
  },

  dateSicknessOrInjuryBegan: {
    id: 'fastCover.medicalExpenseStep.dateSicknessOrInjuryBegan',
    defaultMessage: 'Date Sickness Or Injury began',
  },

  dateFirstTreated: {
    id: 'fastCover.medicalExpenseStep.dateFirstTreated',
    defaultMessage: 'Date First Treated',
  },

  nameOfPhysician: {
    id: 'fastCover.medicalExpenseStep.nameOfPhysician',
    defaultMessage: 'Name Of Physician',
  },

  datesOfTreatment: {
    id: 'fastCover.medicalExpenseStep.datesOfTreatment',
    defaultMessage: 'Date First Treated',
  },

  natureOfInjury: {
    id: 'fastCover.medicalExpenseStep.natureOfInjury',
    defaultMessage: 'Nature Of Injury',
  },
  addDate: {
    id: 'fastCover.medicalExpenseStep.addDate',
    defaultMessage: 'Add Date',
  },
  treatmentDate: {
    id: 'fastCover.medicalExpenseStep.treatmentDate',
    defaultMessage: 'Treatment Date',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.MedicalExpenseStep/messages.js